// extracted by mini-css-extract-plugin
export default {"App":"Yc91e","App-logo":"KKrtp","App-link":"Z6fd0","App-logo-spin":"Bx8zr"};